// extracted by mini-css-extract-plugin
export var orderSummary = "_ph-0";
export var showMoreLessButton = "_ph-1";